export default {
  name: 'dashify:ConditionalSwitch',
  title: 'Condtional Switch',
  owner: 'System',
  solution: '',
  tags: ['html', 'list'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    type: 'info',
    view: [
      [
        'div',
        {},
        [
          [
            'dashify:Select',
            {
              className: 'pt-3 pr-4 w-[400px]',
              value: '/${ type }',
              options: [
                { value: 'error', label: 'Error' },
                { value: 'warning', label: 'Warning' },
                { value: 'info', label: 'Info' },
              ],
              onChange: "/${ function($v) { $set('/type', $v.value ? $v.value : [])} }",
            },
          ],
        ],
      ],
      [
        'div',
        { '.': 'p-2 mt-3' },
        [
          [
            'dashify:Switch',
            {},
            [
              ['dashify:Case', { condition: '/${ type = "error" }' }, [['div', {}, 'Opps you have an error']]],
              ['dashify:Case', { condition: '/${ type = "warning" }' }, [['div', {}, 'Careful you have a warning']]],
              ['dashify:Case', { condition: '/${ type = "info" }' }, [['div', {}, 'All is well']]],
            ],
          ],
        ],
      ],
    ],
  },
};
